module.exports = __webpack_public_path__ + "static/posterOrganise-693520e9b5a1258667f67470ac1da22b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/enterprise/posterOrganise.jpg
// module id = 2572
// module chunks = 168707334958949